// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"36e273d3","232":"ee0d30de","342":"03af08a5","858":"f6d0441c","879":"75e80c46"}[chunkId] + ".css";
};